export const QUOTE_URL = process.env.REACT_APP_QUOTE_URL;
export const EMAIL = "miss_cupcake_creations@outlook.com";
export const LOCATION = "Hillcrest / Logan";
export const BUSINESS_NAME = "Miss Cupcake Creations";

export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=100095181283938",
  instagram: "https://www.instagram.com/miss_cupcake_creations_",
  tiktok: "https://www.tiktok.com/@miss.cupcake.crea",
};
